// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  orgId: __t.string(),
  plan: __t.string(),
  billingStatus: __t.string(),
  interval: __t.string(),
  seats: __t.u32(),
  extraStorageGb: __t.f64(),
  stripeCustomerId: __t.string(),
  stripeSubscriptionId: __t.string(),
  currentPeriodEnd: __t.f64(),
  cancelAt: __t.f64(),
};
